(function () {
  var CLS = "HFB-077-AB--var-1";
  var NAMES = {
    "body-splash-skin-smoothing-body-oil-yummy": "Yummy Body Splash Oil",
    "body-magic-remove-full-body-odor-naturally": "Body Magic Chlorophyll Pills",
    "refresh-ph-balancing-yoni-gel": "Refresh pH Balancing Wash",
    "sweet-skin-body-oil-bundle": "Sweet Skin Oil Bundle",
    "body-splash-skin-smoothing-body-oil-vanilla-drip": "Vanilla Drip Body Splash Oil",
    "fresh-clean-ph-restore-capsules": "Fresh & Clean Boric Suppositories",
    "healthy-box-probiotics": "Healthy Box Probiotics",
    "body-splash-hydrating-body-oil-pineapple-creme": "Pineapple Crème Body Splash Oil",
    "the-everything-bundle": "The Everything Bundle",
    "slippery-box-moisture-capsules": "Slippery Box Moisture Capsules",
    "yummy-body-gel-wash": "Yummy Organic Body Wash",
    "renew-her-booty-kitty-oil": "Renew Her Yoni Oil",
    "fruity-skin-body-oil-bundle": "Fruity Skin Oil Bundle",
    "body-splash-skin-smoothing-body-oil-caramel-glaze": "Caramel Glaze Body Splash Oil",
    "sensitive-probiotic-ph-balanced-wash": "Sensitive Probiotic+ Wash",
    "refresh-3pk": "Refresh pH Wash · 3 pack",
    "body-magic-3pk": "Body Magic Chlorophyll · 3 pack",
    "boric-balance": "Boric Balance Foam Wash",
    "the-fresh-clean-kit": "Fresh & Clean Kit",
    "body-splash-skin-smoothing-body-oil-mental-reset-lavender": "Lavender & Vanilla Body Splash Oil",
    "body-splash-skin-smoothing-body-oil-santal-driftwood": "Santal Driftwood Body Splash Oil",
    "everywhere-wipes": "Everywhere Odor Wipes",
    "body-splash-skin-smoothing-body-oil-blueberry-creme": "Blueberry Crème Body Splash Oil",
    "vita-c-bright-turmeric-body-wash": "Vita C Bright Turmeric Wash"
  };

  function apply() {
    if (!document.documentElement.classList.contains(CLS)) return;
    document.querySelectorAll("[data-product-handle]").forEach(function (card) {
      var handle = card.getAttribute("data-product-handle");
      var next = NAMES[handle];
      if (!next) return;
      card.querySelectorAll(".new-pc-ttle, .spf-product-card__title, .gl-card-title").forEach(function (title) {
        if (title.textContent.replace(/\s+/g, " ").trim() !== next) title.textContent = next;
      });
    });
  }

  function watch() {
    apply();
    var obs = new MutationObserver(apply);
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    if (document.body) obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watch);
  else watch();
})();
